import { atom } from 'jotai';
import { BackendApiUrl } from "@/functions/BackendApiUrl";

export const logoUrlAtom = atom<string>(
  `${BackendApiUrl.blob.download}?fileName=${encodeURIComponent("logo-aplikasi")}`
);